module.exports = __webpack_public_path__ + "img/3.eb1e03a6.png";